import Component from 'gia/Component'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);



class Discover extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)
    this.index = 0
    this.progress = 0

    this.ref = {
      page: [],
      img: [],
      title:[],
      bg: []
    }
  }

  mount() {

 

    


     this.ref.page.forEach((item, i) => {
       
        gsap.fromTo(
            this.ref.img[i], {
                ease: 'none',
                yPercent: 14.28
            }, {
                scrollTrigger: {
                    trigger: item,
                    start: "top top",
                    end: "bottom bottom",
                    scrub: .5
                },
                ease: 'none',
                yPercent: -14.28
            }
        )

        gsap.fromTo(
            this.ref.title[i], {
                    ease: 'none',
                    yPercent: 0
                }, {
                scrollTrigger: {
                    trigger: item,
                    start: "top top-=50%",
                    end: "top top-=150%",
                    scrub: true
                },
                ease: 'none',
                yPercent: -100
            }
        )

        gsap.fromTo(
            this.ref.bg[i], {
                ease: 'none',
                opacity: 0
            }, {
                scrollTrigger: {
                    trigger: item,
                    start: "top top-=50%",
                    end: "top top-=150%",
                    scrub: true
                },
                ease: 'none',
                opacity: 1
            }
        )

     });
  
  }

  changeImg() {

  
  }


  unmount() {

  }


}

module.exports = Discover
